const commonjs = {
	getNowDate(item) {
		if(item == "" || item == "undefined" || item == undefined) {
			return ''
		} else {
			var date = new Date(item);
		}
		var year = date.getFullYear();
		var month = date.getMonth() + 1;
		var strDate = date.getDate();
		if(month >= 1 && month <= 9) {
			month = "0" + month;
		}
		if(strDate >= 0 && strDate <= 9) {
			strDate = "0" + strDate;
		}
		var nowdate = year + '-' + month + '-' + strDate
		return nowdate;
	},
	getUploadHeaders(){
		return {
			Authorization: "Bearer " + sessionStorage.getItem('token')
		}
	}
}
export default commonjs